// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-46797462]{display:flex;flex-direction:column;align-items:center}main .container[data-v-46797462]{max-width:916px;width:100%;margin:auto}", ""]);
// Exports
module.exports = exports;
